import { HotSpot } from './HotSpot';
import { PresetCoordinate, Logic, Phase } from '../Logic/Logic';
import { Chip } from './Chip';
import { Constants } from '../Utils/Constants';
import { Board } from '../../../BaseRoulette/Sources/Board';
import { Client } from '@core/Client';
import { Assets } from './Utils/Assets';
import { PresetButton } from './PresetButton';
import { ButtonState } from './Button';

export class BetsDisplay {
	public touchActive: boolean = false;
	public chipContainer: Phaser.GameObjects.Container

	private chipSize = Constants.BETS_DISPLAY.CHIP_SIZE
	private winNumberPosition = Phaser.Math.Vector2.ZERO
	private lastIgnoredHotspot: HotSpot;
	private touchStartX: number = 0;
	private touchStartY: number = 0;
	private chipTextures: string[]
	private displayedChips = new Array<Array<Chip>>()
	private isTrack: boolean = false
	private canPlaceBet: boolean = true

	private presetChips = new Map<PresetButton, Chip>();

	constructor(private c: Phaser.GameObjects.Container, private scene: Phaser.Scene, private hotSpotTable: HotSpot[][], private assets: any, _isTrack?: boolean, private chipOrigin?: [number, number]) {
		if (_isTrack)
			this.isTrack = _isTrack;

		let o = Assets.betChips;
		this.chipTextures = [];
		for (let i = 0; i < o.length; i++) {
			this.chipTextures.push(o[i].normal);
		}

		this.chipContainer = new Phaser.GameObjects.Container(scene);
		this.displayedChips = new Array(28);
		for (var x = 0; x < this.hotSpotTable.length; x++) {
			this.displayedChips[x] = new Array(11);
		}

		this.scene.game.events.addListener(Constants.EVENTS.PLACE_BET, (coords) => this.RefreshChips(coords), this);

		this.c.add(this.chipContainer)
		this.SetBetDisplayHotSpotRefference();
	}

	get ChipContainer(): Phaser.GameObjects.Container {
		return this.chipContainer
	}

	get IsTrack(): boolean {
		return this.isTrack;
	}

	get LastIgnoredHotspot(): HotSpot {
		return this.lastIgnoredHotspot;
	}

	get TouchActive(): boolean {
		return this.touchActive;
	}

	get TouchStartX(): number {
		return this.touchStartX;
	}

	get TouchStartY(): number {
		return this.touchStartY;
	}

	SetPresetButtons(presetButtons: Array<PresetButton>): void {
		this.presetChips = new Map<PresetButton, Chip>();
		presetButtons.forEach(button => {
			this.presetChips.set(button, null);
		});
	}

	SetChipSize(size: number): void {
		this.chipSize = size
	}

	SetWinPosition(position: Phaser.Math.Vector2): void {
		this.winNumberPosition = position
		Client.logic.BetFields.forEach((element, x) => {
			element.forEach((v, y) => {
				let c = this.displayedChips[x][y]
				if (!c) return
				if (v.WonCredit == 0) {
					let thisHotspotCenter = this.hotSpotTable[x][y].Center
					thisHotspotCenter.x = this.hotSpotTable[x][y].x
					thisHotspotCenter.y = this.hotSpotTable[x][y].y
					let radius = Phaser.Math.Distance.BetweenPoints(this.winNumberPosition, thisHotspotCenter)
					let velocitySize = Constants.BETS_DISPLAY.WIN_EXPLOSION_FORCE / Math.pow(radius, 1.5)
					c.VelocityX = velocitySize * (thisHotspotCenter.x - this.winNumberPosition.x) / radius
					c.VelocityY = velocitySize * (thisHotspotCenter.y - this.winNumberPosition.y) / radius
				}
				else {
					c.VelocityX = 0
					c.VelocityY = 0
				}
			});
		});

		//for preset buttons if they exist on this view
		if(this.presetChips)
		{
			this.presetChips.forEach((chip, button) => {
				if (!chip) 
					return;

				let winning:boolean = false;
				let winningCoordinate:PresetCoordinate | null = null;
				button.coveringFields.forEach(coordinate => {
					if(Client.logic.BetFields[coordinate.X][coordinate.Y].WonCredit != 0)
					{
						winningCoordinate = coordinate;
						winning = true;
						return;
					}
				});

				if (winning && winningCoordinate) {
					let thisHotspotCenter = this.hotSpotTable[winningCoordinate.X][winningCoordinate.Y].Center;
					thisHotspotCenter.x = this.hotSpotTable[winningCoordinate.X][winningCoordinate.Y].x;
					thisHotspotCenter.y = this.hotSpotTable[winningCoordinate.X][winningCoordinate.Y].y;
					let radius = Phaser.Math.Distance.BetweenPoints(this.winNumberPosition, thisHotspotCenter);
					let velocitySize = Constants.BETS_DISPLAY.WIN_EXPLOSION_FORCE / Math.pow(radius, 1.5);
					chip.VelocityX = velocitySize * (thisHotspotCenter.x - this.winNumberPosition.x) / radius;
					chip.VelocityY = velocitySize * (thisHotspotCenter.y - this.winNumberPosition.y) / radius;
				}
				else {
					chip.VelocityX = 0;
					chip.VelocityY = 0;
				}
			});
		}
	}

	SetBetDisplayHotSpotRefference(): void {
		if (this.isTrack) {
			this.hotSpotTable[0][3].SetBetsDisplay(this);
			if (Client.logic.AsChevalsBet) {
				this.hotSpotTable[0][9].SetBetsDisplay(this);
				this.hotSpotTable[0][10].SetBetsDisplay(this);
			}
			if (Client.logic.IsDoubleZero())
				this.hotSpotTable[0][1].SetBetsDisplay(this)
		}
		else {
			this.hotSpotTable[0][3].SetBetsDisplay(this);
			if (Client.logic.IsDoubleZero()) this.hotSpotTable[0][1].SetBetsDisplay(this)
		}

		for (let x = 1; x < this.hotSpotTable.length; x++) {
			for (let y = 0; y < this.hotSpotTable[x].length; y++) {
				if (this.hotSpotTable[x][y]) this.hotSpotTable[x][y].SetBetsDisplay(this);
			}
		}
	}

	RefreshChips(coords?: number[]): void {
		Client.logic.BetFields.forEach((element, x) => {
			element.forEach((c, y) => {
				let displayedChip = this.displayedChips[x][y]
				if (!this.hotSpotTable[x][y]) return
				if (c.BetCredit > 0 || (c.HiddenCredit > 0 && Client.logic.IsBoard)) {
					if (!displayedChip) {
						this.displayedChips[x][y] = new Chip(this.scene, Assets.chipAtlas, "chip2_N.png", 0, 0, this.chipSize, this.chipSize, "0", this.chipOrigin)
						displayedChip = this.displayedChips[x][y]
						this.chipContainer.add(this.displayedChips[x][y])
					}
					let t = ""

					if (Client.logic.IsBoard)
						for (var i = 0; i < this.chipTextures.length; i++) {
							if ((c.BetCredit + c.HiddenCredit) >= Client.logic.ChipValues[i] && ((i + 1) == Client.logic.ChipValues.length || 0 == Client.logic.ChipValues[i + 1] || (c.BetCredit + c.HiddenCredit) < Client.logic.ChipValues[i + 1])) {
								t = this.chipTextures[i]
							}
						}
					else
						for (var i = 0; i < this.chipTextures.length; i++) {
							if (c.BetCredit >= Client.logic.ChipValues[i] && ((i + 1) == Client.logic.ChipValues.length || 0 == Client.logic.ChipValues[i + 1] || c.BetCredit < Client.logic.ChipValues[i + 1])) {
								t = this.chipTextures[i]
							}
						}

					if (coords && coords[0] == x && coords[1] == y) this.chipContainer.bringToTop(displayedChip);
					displayedChip.visible = true;
					displayedChip.ChangeTexture(t);
					
					if (Client.logic.IsBoard)
						displayedChip.Text = (c.BetCredit + c.HiddenCredit).toString();
					else
						displayedChip.Text = c.BetCredit.toString();

					displayedChip.angle = 0;

					if (c.HiddenCredit > 0 && c.BetCredit == 0)
						displayedChip.alpha = 0.75;
					else
						displayedChip.alpha = 1.0;

					this.positionChip(x, y, displayedChip);
				} else if (displayedChip) {
					displayedChip.visible = false;
					this.positionChip(x, y, displayedChip);
				}
			});
		});

		if (this.presetChips) {
			this.presetChips.forEach((chip, button) => {
				let cashOnPreset: number = Client.logic.BetPresets.get(button.name).bet;
				if (cashOnPreset > 0) {
					if (!chip) {
						this.presetChips.set(button, new Chip(this.scene, Assets.chipAtlas, "chip2_N.png", 0, 0, this.chipSize, this.chipSize, "0", this.chipOrigin));
						chip = this.presetChips.get(button);
						this.chipContainer.add(chip);
					}

					let t = ""
					for (var i = 0; i < this.chipTextures.length; i++) {
						if (cashOnPreset >= Client.logic.ChipValues[i] && ((i + 1) == Client.logic.ChipValues.length || 0 == Client.logic.ChipValues[i + 1] || cashOnPreset < Client.logic.ChipValues[i + 1])) {
							t = this.chipTextures[i]
						}
					}
					chip.visible = true;
					chip.ChangeTexture(t);
					chip.Text = cashOnPreset.toString();
					chip.angle = 0;

					let g = this.hotSpotTable[6][3] // must be here to set all chips equal sizes as opposed to the size of their corresponding hotspots

					chip.setDisplaySize(this.chipSize * g.scaleX, this.chipSize * g.scaleX);
					chip.setPosition(button.x + button.buttonBase.displayWidth/2, button.y + button.buttonBase.displayHeight/2);
				}
				else if (chip) {
					chip.visible = false;
				}
			});
		}
	}

	Update(time: number): void {
		if (!Client.logic.BetsAllowed && Client.logic.CurrentWinNumber != -1 && Client.logic.Phase != Phase.SHOWING_HISTORY_REPLAY) {
			Client.logic.BetFields.forEach((element, x) => {
				element.forEach((v, y) => {
					let c = this.displayedChips[x][y]
					if (!c) return
					if (v.WonCredit > 0)
						c.angle += Constants.BETS_DISPLAY.WIN_ROTATION_SPEED * time
					else {
						let elapsedTime = time * Constants.BETS_DISPLAY.WINFALL_SPEED * 0.001
						let pixelsPerCM = 100 * window.devicePixelRatio / 2.54
						c.VelocityY += elapsedTime * pixelsPerCM * 9.81 * 100
						c.x += c.VelocityX * elapsedTime
						c.y += c.VelocityY * elapsedTime
					}
				});
			});

			//for preset buttons if they exist on this view
			if (this.presetChips) {
				this.presetChips.forEach((chip, button) => {
					if (!chip)
						return;

					if(button.state == ButtonState.Win)
					{
						chip.angle += Constants.BETS_DISPLAY.WIN_ROTATION_SPEED * time
					}else {
						let elapsedTime = time * Constants.BETS_DISPLAY.WINFALL_SPEED * 0.001
						let pixelsPerCM = 100 * window.devicePixelRatio / 2.54
						chip.VelocityY += elapsedTime * pixelsPerCM * 9.81 * 100
						chip.x += chip.VelocityX * elapsedTime
						chip.y += chip.VelocityY * elapsedTime
					}
				});
			}
		}
	}

	ToggleTouchPointer(_touchActive: boolean): void {
		this.touchActive = _touchActive;
	}

	DoLinearInterpolation(_x: number, _y: number, ignoreHotspot: HotSpot): void {
		if (!this.isTrack) (this.c as Board).DoLinearInterpolation(_x, _y, ignoreHotspot);
	}

	SetStartingTouchPosition(x: number, y: number, ignoreHotspot: HotSpot) {
		this.touchStartX = x;
		this.touchStartY = y;
		this.lastIgnoredHotspot = ignoreHotspot;
	}

	private positionChip(x: number, y: number, chip: Chip): void {
		let h: HotSpot = this.hotSpotTable[x][y]
		let g = this.hotSpotTable[6][3] // must be here to set all chips equal sizes as opposed to the size of their corresponding hotspots
		let posX: number;
		let posY: number;

		if ((Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) ||
			(Client.logic.Phase != Phase.READING_WIN_NUMBER_STATE && Client.logic.CurrentWinNumber == -1) ||
			(Client.logic.CurrentWinNumber != -1 && (Client.logic.BetFields[x][y].WonCredit > 0))
		) {
			if (this.isTrack) {
				posX = h.x + h.offsetX;
				posY = h.y + h.offsetY;
			} else {
				posX = h.x + (h.displayWidth / 2) + (h.OffsetX ? (h.OffsetX * g.scaleX) : 0);
				posY = h.y + (h.displayHeight / 2) + (h.OffsetY ? (h.OffsetY * g.scaleY) : 0);
			}
		}

		chip.setPosition(posX, posY);
		chip.setDisplaySize(this.chipSize * g.scaleX, this.chipSize * g.scaleX)
	}
}
